import { useTranslation } from 'react-i18next'

import { useMutation } from 'components/graphql'
import { ConfirmModal } from 'components/Modal'

export default ({ sectionData, recordId, onItemDeleted }) => {
	const delMutation = sectionData?.deleteMutation
	const [mutate] = useMutation(delMutation, {
		onCompleted: (data) => {
			if (onItemDeleted && typeof onItemDeleted === 'function') {
				const deletedId = data?.cashAssist?.deleteScheduleTask?.id
				onItemDeleted(deletedId ?? recordId)
			}
		}
	})
	const [t] = useTranslation()

	const handler = (id, itemData) => {
		if(!delMutation) {
			return
		}
		const callDelMutation = () => {
			mutate({
				variables: { deleteScheduleTaskId: id, taskType: itemData?.taskType }
			})
		}

		ConfirmModal({
			text: t('common.strings.sure_delete'),
			label: t('common.strings.delete_data')
		}).then(
			() => callDelMutation()
		).catch(() => {})
	}
	return handler
}
